import { Component, xml, useState } from "@odoo/owl";

class SearchForm extends Component {
    static template = xml`
        <form t-on-submit.prevent="submitForm">
            <div>
                <label for="decision_number">Határozatszám:</label>
                <input type="text" id="decision_number" name="decision_number" t-model="state.formValues.decision_number"/>
            </div>
            <div>
                <label for="subject">Tárgy:</label>
                <input type="text" id="subject" name="subject" t-model="state.formValues.subject"/>
            </div>
            <div>
                <label for="institution">Intézmény:</label>
                <input type="text" id="institution" name="institution" t-model="state.formValues.institution"/>
            </div>
            <div>
                <label for="decision_date">Határozat Dátuma:</label>
                <input type="date" id="decision_date" name="decision_date" t-model="state.formValues.decision_date"/>
            </div>
            <div>
                <label for="type">Típus:</label>
                <select id="beadvany_tipusa" name="type" t-model="state.formValues.type">
                    <option value="">-- Válasszon --</option>
                    <t t-foreach="getTypeOptions()" t-as="typeOption" t-key="typeOption.value">
                        <option t-att-value="typeOption.value" t-esc="typeOption.label"/>
                    </t>
                </select>
            </div>
            <div>
                <button type="submit">Keresés</button>
            </div>
        </form>
    `;

    setup() {
        this.state = useState({
            formValues: this.props.search_params || {
                decision_number: "",
                subject: "",
                decision_date: "",
                type: "",
            }
        });
    }

    /**
     * Metadata alapján visszaadja a típus opciókat
     */
    getTypeOptions() {
        // Ha nincs metadata, üres lista
        if (!this.props.metadata || !this.props.metadata.types) {
            return [];
        }

        // Metadata.types objektumból opciók generálása
        return Object.keys(this.props.metadata.types).map(typeKey => ({
            value: typeKey,
            label: this.props.metadata.types[typeKey].name || typeKey
        }));
    }

    submitForm() {
        // Csak a nem üres értékeket továbbítjuk
        const searchParams = Object.fromEntries(
            Object.entries(this.state.formValues).filter(([key, value]) => value !== "")
        );
        this.props.onSearch(searchParams);
    }
}

export default SearchForm;
